export const useEnvironment = () => {
	const { environment } = useRuntimeConfig().public

	return {
		environment,
		isLocal: environment === 'local',
		isDev: environment === 'dev',
		isStage: environment === 'stage',
		isProd: environment === 'prod',
	}
}
